import { render, staticRenderFns } from "./Tnc.vue?vue&type=template&id=1cc092a3&"
import script from "./Tnc.vue?vue&type=script&lang=js&"
export * from "./Tnc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports